module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }